(function () {
  function initScrollSplit() {
      
    var container = document.querySelector(
      '.product__info-container--sticky[data-scroll-split]'
    );
    if (!container) return;

    var buyButtonsBlock = container.querySelector('product-form');
    if (!buyButtonsBlock) return;

    var buyButtonsDiv = buyButtonsBlock.closest('[id^="shopify-block"]') || buyButtonsBlock.parentNode;

    var scrollTop = document.createElement('div');
    scrollTop.className = 'product__info-scroll-top';

    var stickyBottom = document.createElement('div');
    stickyBottom.className = 'product__sticky-bottom';

    var children = Array.from(container.children);
    var splitFound = false;

    children.forEach(function (child) {
      if (!splitFound && (child === buyButtonsDiv || child.contains(buyButtonsBlock))) {
        splitFound = true;
      }
      if (splitFound) {
        stickyBottom.appendChild(child);
      } else {
        scrollTop.appendChild(child);
      }
    });

    container.appendChild(scrollTop);
    container.appendChild(stickyBottom);

    // Czekaj 800ms na wyrenderowanie wtyczek (RIO, EBT)
    setTimeout(function () {
      var naturalHeight = scrollTop.scrollHeight;
      if (naturalHeight > 520) {
        scrollTop.style.height = '520px';
      } else {
        scrollTop.style.height = naturalHeight + 'px';
        scrollTop.style.overflowY = 'visible';
      }
    }, 800);
  }

  if (document.readyState === 'complete') {
    initScrollSplit();
  } else {
    window.addEventListener('load', initScrollSplit);
  }
})();
